import { create } from 'zustand';
import { ThemeStore } from '@modules/theme/store/types';
import { THEME_MODE_STORAGE_KEY, ThemeMode } from '@modules/theme/constants';
import Locker from 'lockr';
import { getDefaultThemeMode } from '@modules/theme/store/helpers/getDefaultThemeMode';

export const useThemeStore = create<ThemeStore>((set) => ({
  mode: getDefaultThemeMode(),
  setMode: (mode: ThemeMode) => {
    if (Locker.get(THEME_MODE_STORAGE_KEY) !== mode) {
      Locker.set(THEME_MODE_STORAGE_KEY, mode);
    }
    set({ mode });
  },
}));
